// The faction the player's screen is showing (Home shields, Profile, Settings).
// FactionContext keeps it in localStorage "chess_faction". Sent with every
// new game / join so the server seats the player in the faction they see.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VALID = ["iron-kingdom", "dragonborn", "elf-court", "celestial-host"];

export function getShownFaction() {
  try {
    const v = window.localStorage.getItem("chess_faction");
    return VALID.includes(v) ? v : undefined;
  } catch (e) {
    return undefined;
  }
}

// Save a Home-shield pledge to the account (same call the Navigator uses),
// so the Profile page no longer resets it on the next visit.
export function saveFactionPledge(value) {
  return axios.put(`${API}/profile/me`, { faction: value }, { withCredentials: true }).catch(() => null);
}
